/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderFieldName {
  FIRSTNAME = 'firstname',
  LASTNAME = 'lastname',
  EMAIL = 'email',
  PHONE = 'phone',
  PERSONS = 'persons',
  DATE = 'date',
  TIME = 'time',
  PRICE = 'price',
  DURATION = 'duration',
  CUSTOM_DETAILS = 'custom_details',
  COMMENT = 'comment',
  EVENT_ID = 'event_id',
  ORDER_PAGE_ID = 'order_page_id',
  EMPLOYEE_IDS = 'employee_ids',
  RESOURCE_INDEXES = 'resource_indexes',
  MANUAL_RESOURCE_HOLDS = 'manual_resource_holds',
  CHECKIN_PERSONS = 'checkin_persons',
  GUEST_NAME = 'guest_name',
  EXTERNAL_VOUCHER_CODE = 'external_voucher_code',
  PROJECT_SELECTION = 'project_selection',
  STATUS = 'status',
  EXTRA_PAYMENT_AMOUNT = 'extra_payment_amount',
  EXTRA_PAYMENT_LABEL = 'extra_payment_label',
  EXTRA_PAYMENT_METHOD = 'extra_payment_method',
}
